import React from 'react'
import HeaderComponent from '../HeaderComponent'
import BannerComponent from './BannerComponent'
import FooterComponent from '../FooterComponent'

export default function PrincipalComponent() {
  return (
    <>
        <HeaderComponent />
        <br />
        <BannerComponent />
        <br />
        <FooterComponent />
    </>
  )
}
